import { CTabView } from "src/components/CTabView";
import { OperationalDashboardPanel } from "./operational-dashboard-panel";
import { FinancialDashboardPanel } from "./financial-dashboard-panel";
import { useSelector } from "react-redux";
import { Slices } from "src/constants";

export function Dashboard() {

  const { user } = useSelector(
    (state: any) => state[Slices.LOGIN_INFORMATION]
  );

  return (
    <>
      <CTabView
        data={[
          {
            label: "OPERATIONAL DASHBOARD",
            component: <OperationalDashboardPanel />,
          },
          user?.role?.name.trim()==='Admin' && {
            label: "FINANCIAL DASHBOARD",
            component: <FinancialDashboardPanel />,
          },
        ]}
      />
    </>
  );
}
